<template>
    <div>
        <label class="form-label">
            <h6>Ajouter un commentaire</h6>
        </label>
        <textarea v-model="content" class="form-control" rows="3" :placeholder="placeholder" :disabled="disabled"
            @keyup.ctrl.enter="submit"></textarea>
        <div class="d-flex justify-content-between align-items-center mt-2">
            <small class="text-muted">{{ remaining }} caract. restants</small>
            <button class="btn btn-primary btn-sm" @click="submit" :disabled="disabled || !canSend"
                title="Ctrl+Entrée pour envoyer">
                Publier
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CommentComposer',
    props: {
        disabled: { type: Boolean, default: false },
        maxLength: { type: Number, default: 2000 },
        placeholder: {
            type: String,
            default:
                "Exemple : Sortie de corridoring suite à déviation au niveau de l'A6, autorisée par le client",
        },
    },
    data() {
        return { content: '' };
    },
    computed: {
        trimmed() {
            return (this.content || '').trim();
        },
        canSend() {
            return this.trimmed.length > 0 && this.trimmed.length <= this.maxLength;
        },
        remaining() {
            return this.maxLength - this.content.length;
        },
    },
    methods: {
        submit() {
            if (!this.canSend || this.disabled) return;
            this.$emit('submit', this.trimmed);
            this.content = '';
        },
    },
};
</script>
